"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.serviceabilityOptionsSchema = exports.EServiceType = exports.EServiceCatchment = void 0;
const zod_1 = require("zod");
var EServiceCatchment = /*#__PURE__*/function (EServiceCatchment) {
  EServiceCatchment[EServiceCatchment["small"] = 5] = "small";
  EServiceCatchment[EServiceCatchment["medium"] = 8] = "medium";
  EServiceCatchment[EServiceCatchment["large"] = 15] = "large";
  return EServiceCatchment;
}(EServiceCatchment || (exports.EServiceCatchment = EServiceCatchment = {}));
var EServiceType = /*#__PURE__*/function (EServiceType) {
  EServiceType["postcode"] = "postcode";
  EServiceType["geopoint"] = "geopoint";
  EServiceType["address"] = "address";
  EServiceType["placeid"] = "placeid";
  return EServiceType;
}(EServiceType || (exports.EServiceType = EServiceType = {}));
exports.serviceabilityOptionsSchema = zod_1.z.object({
  type: zod_1.z.enum(["geopoint", "address", "postcode", "placeid"]),
  bupa: zod_1.z.boolean().optional().default(false),
  value: zod_1.z.string(),
  allow_postal: zod_1.z.boolean().optional().default(false),
  driving_time: zod_1.z.boolean().optional().default(false),
  estimate: zod_1.z.boolean().optional().default(false),
  catchment: zod_1.z.enum(["small", "medium", "large", "custom"]).optional().default("medium"),
  range: zod_1.z.number().optional(),
  date: zod_1.z.preprocess(arg => typeof arg === "string" || arg instanceof Date ? new Date(arg) : arg, zod_1.z.date().refine(d => d > new Date(), {
    message: "Date must be in the future"
  })).optional(),
  pharmacy: zod_1.z.boolean().optional().default(false),
  clickAndCollect: zod_1.z.boolean().optional().default(false),
  fee: zod_1.z.boolean().optional().default(false),
  ignore_status: zod_1.z.boolean().optional().default(false),
  ignore_schedule: zod_1.z.boolean().optional().default(false),
  ignore_holiday: zod_1.z.boolean().optional().default(false)
}).superRefine((data, ctx) => {
  switch (data.type) {
    case "geopoint":
      {
        if (!data.value.includes(",")) {
          ctx.addIssue({
            code: zod_1.z.ZodIssueCode.custom,
            message: "Geopoint format is invalid. Use latitude,longitude",
            path: ["value"]
          });
        } else {
          const [lat, lng] = data.value.split(",").map(s => s.trim());
          if (!lat || !lng) {
            ctx.addIssue({
              code: zod_1.z.ZodIssueCode.custom,
              message: "Geopoint format is invalid. Use latitude,longitude",
              path: ["value"]
            });
          } else {
            const pattern = /^-?\d+(\.\d+)?\s*,\s*-?\d+(\.\d+)?$/;
            if (!pattern.test(`${lat},${lng}`)) {
              ctx.addIssue({
                code: zod_1.z.ZodIssueCode.custom,
                message: "Geopoint format is invalid. Use latitude,longitude",
                path: ["value"]
              });
            }
          }
        }
        break;
      }
    case "address":
      {
        if (!data.value.trim()) {
          ctx.addIssue({
            code: zod_1.z.ZodIssueCode.custom,
            message: "Address format is invalid",
            path: ["value"]
          });
        }
        break;
      }
    case "postcode":
      {
        if (!/^[0-9]{4}$/.test(data.value)) {
          ctx.addIssue({
            code: zod_1.z.ZodIssueCode.custom,
            message: "Postcode format is invalid. Use 4 digits",
            path: ["value"]
          });
        }
        break;
      }
    case "placeid":
      {
        if (data.value.length < 27) {
          ctx.addIssue({
            code: zod_1.z.ZodIssueCode.custom,
            message: "Placeid format is invalid",
            path: ["value"]
          });
        }
        break;
      }
  }
  if (data.catchment === "custom" && (data.range === undefined || data.range === null)) {
    ctx.addIssue({
      code: zod_1.z.ZodIssueCode.custom,
      message: "Range is required when catchment is custom",
      path: ["range"]
    });
  }
});
